/*
 * Purpose : common component to display bar chart
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */
import React from 'react';
import {Bar} from 'react-chartjs-2';

import {toolChartLabels, toolChartLegend} from './../../config/constants';

const BarChart = (props) => {
  const state = {
    labels: toolChartLabels,//['last 10 days', 'last 30 days', 'last 60 days'],
    datasets: [
      {
        label: toolChartLegend,
        backgroundColor: 'rgba(75,192,192,1)',
        borderColor: 'rgba(0,0,0,1)',
        borderWidth: 2,
        data: props.dataArr//[9, 40, 120]
      }
    ]
  }
  return (
    <div>
      <Bar
        data={state}
        //width={100}
        height={250}
        options={{
          //maintainAspectRatio: false,
          responsive: true,
          title:{
            display:false,
            text:'',
            fontSize:20
          },
          legend:{
            display:true,
            position:'bottom'
          },
          scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
        }}
      />
    </div>
  );  
}
export default BarChart;